import { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft, Inbox, ScanText } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { InboxList } from "@/components/email-inbox/InboxList";
import { InboxDetail } from "@/components/email-inbox/InboxDetail";
import { EmailParserDialog } from "@/components/email-inbox/EmailParserDialog";
import { INBOX_TABS } from "@/components/email-inbox/status";

export default function InboxPage() {
	const { id } = useParams<{ id: string }>();
	const [params, setParams] = useSearchParams();
	const tab = params.get("tab") ?? INBOX_TABS[0].key;
	const [parserOpen, setParserOpen] = useState(false);

	return (
		<div className="mx-auto max-w-[1280px] px-4 py-8 sm:px-6">
			<div className="mb-6 flex flex-wrap items-start justify-between gap-3">
				<div>
					<h1 className="text-2xl font-semibold tracking-tight text-foreground">Inbox</h1>
					<p className="mt-1 text-sm text-muted">
						Task drafts from emails sent to TaskHub or pasted into the Email Parser. Nothing is created until you approve.
					</p>
				</div>
				<Button size="sm" onClick={() => setParserOpen(true)}>
					<ScanText className="h-4 w-4" aria-hidden /> Email Parser
				</Button>
			</div>
			<EmailParserDialog open={parserOpen} onOpenChange={setParserOpen} />

			<div className="grid gap-6 lg:grid-cols-[340px_minmax(0,1fr)]">
				<div className={cn(id && "hidden lg:block")}>
					<InboxList tab={tab} onTabChange={(t) => setParams({ tab: t })} selectedId={id} />
				</div>

				<div className={cn(!id && "hidden lg:block")}>
					{id ? (
						<>
							<Link
								to={`/inbox?tab=${tab}`}
								className="mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground lg:hidden"
							>
								<ArrowLeft className="h-4 w-4" aria-hidden /> Back to inbox
							</Link>
							<InboxDetail key={id} id={id} />
						</>
					) : (
						<div className="flex h-full min-h-[240px] flex-col items-center justify-center rounded-xl border border-dashed border-border p-8 text-center">
							<Inbox className="mb-2 h-6 w-6 text-muted" aria-hidden />
							<p className="text-sm text-muted">Select an email to review its task draft.</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
